import { type DriveFile } from '@/shared/DriveTypes';
import { isAFolder, isNullable } from './utils';

const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
export const sortByNameAndFolder = (arr: DriveFile[]) => {
  return arr.sort((a, b) => {
    const isA = isAFolder(a);
    const isB = isAFolder(b);

    if (isA === isB) return collator.compare(a.name, b.name);
    return isA ? -1 : 1;
  });
};

export const sortByName = (a: DriveFile, b: DriveFile) => collator.compare(a.name, b.name);
export const hasIndex = (file: DriveFile): file is DriveFile & { properties: { index: string } } =>
  !isNullable(file.properties?.index);

export const sortByIndex = (files: DriveFile[]): DriveFile[] => {
  if (files.length <= 1) return files;

  const indexedFiles = files
    .filter(hasIndex)
    .sort((a, b) => Number(a?.properties?.index) - Number(b?.properties?.index));

  if (indexedFiles.length === 0) return files;

  const unindexedFiles = files.filter((o) => !hasIndex(o));
  const result: DriveFile[] = [];
  let idx = 0;
  let shift = 0;
  for (let i = 0; i < unindexedFiles.length; i++) {
    while (idx < indexedFiles.length && Number(indexedFiles[idx]?.properties.index) <= i + shift) {
      const file = indexedFiles[idx];
      if (file) result.push(file);
      idx++;
      shift++;
    }
    const file = unindexedFiles[i];
    if (file) result.push(file);
  }

  while (idx < indexedFiles.length) {
    const file = indexedFiles[idx];
    if (file) result.push(file);
    idx++;
  }
  return result;
};

export const sort = (arr: DriveFile[]) => sortByIndex(sortByNameAndFolder(arr));
